module.exports = __webpack_public_path__ + "static/media/product-img.e7ce9b39.svg";